import { Plus } from "lucide-react";

export default function AdminHeader({ title, buttonText, onClick }) {
  return (
    <div
      className="
        w-full
        flex flex-col lg:flex-row
        lg:items-center
        justify-between
        gap-4 sm:gap-5
        mb-6 md:mb-8 lg:mb-10
      "
    >
      <div className="min-w-0">
        <h2
          className="
            text-xl
            sm:text-2xl
            lg:text-3xl
            font-black
            uppercase
            tracking-tight
            text-white
            flex
            items-start
            sm:items-center
            gap-3
            break-words
          "
        >
          <span
            className="
              shrink-0
              h-7
              sm:h-8
              lg:h-9
              w-1
              sm:w-1.5
              bg-blue-500
              rounded-full
              shadow-lg
            "
          />

          {title}
        </h2>
      </div>

      {buttonText && (
        <button
          onClick={onClick}
          className="
            w-full
            lg:w-fit
            flex
            items-center
            justify-center
            gap-2
            px-5
            sm:px-7
            py-2.5
            sm:py-3
            rounded-xl
            bg-blue-600
            hover:bg-blue-500
            text-white
            text-sm
            sm:text-base
            font-bold
            transition-all
            duration-300
            shadow-lg
            shadow-blue-600/20
            active:scale-95
          "
        >
          <Plus size={18} className="shrink-0" />
          {buttonText}
        </button>
      )}
    </div>
  );
}
